import React from 'react';
import { FaPlus, FaTimes } from 'react-icons/fa';
import {
  LANGUAGE_OPTIONS,
  LANGUAGE_LEVEL_OPTIONS
} from '../../constants/employeeOptions';

const rowStyle = { display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' };

const removeButtonStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '30px',
  height: '30px',
  border: 'none',
  borderRadius: '8px',
  background: 'rgba(239, 68, 68, 0.1)',
  color: '#ef4444',
  cursor: 'pointer',
  flexShrink: 0
};

const addButtonStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  padding: '6px 12px',
  border: '1px dashed #94a3b8',
  borderRadius: '8px',
  background: 'transparent',
  color: 'inherit',
  fontSize: '0.85rem',
  cursor: 'pointer'
};

// Dil + seviye çiftlerini düzenleyen alan. `entries` [{language, level}] dizisidir;
// kalıcı format (string) dönüşümü employeeOptions.js yardımcılarıyla yapılır.
// `styles` prop'u, kullanıldığı modalın CSS module'ü (formSelect sınıfı için).
const LanguageInfoField = ({ entries, onChange, styles }) => {
  const update = (index, patch) =>
    onChange(entries.map((e, i) => (i === index ? { ...e, ...patch } : e)));
  const remove = (index) => onChange(entries.filter((_, i) => i !== index));
  const add = () => onChange([...entries, { language: '', level: '' }]);

  return (
    <div>
      {entries.map((entry, index) => {
        const customLanguage =
          entry.language && !LANGUAGE_OPTIONS.includes(entry.language);
        const customLevel = entry.level && !LANGUAGE_LEVEL_OPTIONS.includes(entry.level);
        return (
          <div key={index} style={rowStyle}>
            <select
              className={styles.formSelect}
              value={entry.language}
              onChange={(e) => update(index, { language: e.target.value })}
              aria-label="Dil"
            >
              <option value="">Dil seçiniz</option>
              {customLanguage && (
                <option value={entry.language}>{entry.language} (liste dışı)</option>
              )}
              {LANGUAGE_OPTIONS.map((lang) => (
                <option key={lang} value={lang}>{lang}</option>
              ))}
            </select>
            <select
              className={styles.formSelect}
              value={entry.level}
              onChange={(e) => update(index, { level: e.target.value })}
              aria-label="Seviye"
            >
              <option value="">Seviye</option>
              {customLevel && (
                <option value={entry.level}>{entry.level} (liste dışı)</option>
              )}
              {LANGUAGE_LEVEL_OPTIONS.map((level) => (
                <option key={level} value={level}>{level}</option>
              ))}
            </select>
            <button
              type="button"
              style={removeButtonStyle}
              onClick={() => remove(index)}
              title="Bu dili kaldır"
              aria-label="Bu dili kaldır"
            >
              <FaTimes />
            </button>
          </div>
        );
      })}
      <button type="button" style={addButtonStyle} onClick={add}>
        <FaPlus /> Dil Ekle
      </button>
    </div>
  );
};

export default LanguageInfoField;
